module.exports = __webpack_public_path__ + "media/images/portugal_center/Ovosmoles-c9d3a1f7881eead52700cd50fa71b634.jpeg";